import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie, Check, X } from "lucide-react";

const STORAGE_KEY = "lmb_cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show banner only if no choice has been recorded yet
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  const save = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, date: new Date().toISOString() }));
      window.dispatchEvent(new CustomEvent("lmb-cookie-consent", { detail: { choice } }));
    } catch {}
    setOpen(false);
  };

  // Hide banner on admin routes (avoids overlaying admin action buttons)
  if (location.pathname.startsWith("/admin")) return null;
  if (!open) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[60] p-2 sm:p-5 pb-[max(0.5rem,env(safe-area-inset-bottom))] animate-in slide-in-from-bottom duration-300">
      <div className="mx-auto max-w-5xl bg-[#072135] text-white border sm:border-2 border-[#D8B86A] rounded-sm shadow-2xl">
        <div className="p-3 sm:p-6 flex flex-col lg:flex-row lg:items-center gap-2.5 sm:gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="hidden sm:flex w-10 h-10 flex-shrink-0 bg-[#D8B86A] items-center justify-center rounded-sm">
              <Cookie size={20} className="text-[#072135]" strokeWidth={2.5} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="hidden sm:block font-heading font-black text-lg leading-tight mb-1">Nous utilisons des cookies</div>
              <p className="text-xs sm:text-sm text-white/80 leading-snug sm:leading-relaxed">
                <span className="sm:hidden">Cookies techniques + mesure d'audience anonyme.{" "}</span>
                <span className="hidden sm:inline">Cookies techniques nécessaires + cookies de mesure d'audience anonyme pour améliorer le site.
                Aucune donnée personnelle n'est revendue.{" "}</span>
                <Link to="/cgv?doc=mentions-legales" className="text-[#D8B86A] hover:underline whitespace-nowrap">En savoir plus →</Link>
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:flex gap-2 flex-shrink-0">
            <button
              onClick={() => save("rejected")}
              data-testid="cookie-reject"
              className="inline-flex items-center justify-center gap-1.5 px-4 py-2 sm:py-2.5 border-2 border-white/40 hover:border-white text-white font-heading font-black uppercase tracking-wider text-xs rounded-sm transition-colors"
            >
              <X size={13} /> Refuser
            </button>
            <button
              onClick={() => save("accepted")}
              data-testid="cookie-accept"
              className="inline-flex items-center justify-center gap-1.5 px-5 py-2 sm:py-2.5 bg-[#D8B86A] hover:bg-[#c2a45d] text-[#072135] font-heading font-black uppercase tracking-wider text-xs rounded-sm transition-colors"
            >
              <Check size={13} /> Accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
